import { render } from "./Sementara.vue?vue&type=template&id=e8805e8a"
import script from "./Sementara.vue?vue&type=script&lang=js"
export * from "./Sementara.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__